<template>
    <div class="main">





        <BasicDialog @close="closeClicked">
            <v-row no-gutters class="flex-column mx-sm-16 px-sm-16">


                <v-row no-gutters class="justify-center">
                    <img :src="AppConfigs.staticImages.VERIFYPHONENUMBERDIALOG">
                </v-row>





                <v-row no-gutters class="d-flex justify-center text-center mt-4 flex-column">

                    <span class="text-h5 font-weight-bold">Verify Your Phone Number</span>
                    <span class="text-body-2 mt-1">Earn 100 coins by verifying your phone number</span>

                </v-row>





                <v-row no-gutters class="mt-10 px-sm-16">
                    <v-col cols="12">


                        <span style="opacity: .8; font-size: 15px;">Phone Number</span>


                        <vue-tel-input v-model="phone" mode="international"
                            :onlyCountries="countries.map(({ region_code }) => region_code)"
                            :defaultCountry="defaultCountry.region_code" :autoFormat="false" :dropdownOptions="{
                            showFlags: true,
                            showDialCodeInList: true,
                            showDialCodeInSelection: true
                        }" @country-changed="onCountryChange" class="mt-1" />


                        <div class="text-caption mt-2" style="text-align: center;">
                            A 6 digit OTP will be sent via SMS to verify your mobile number!
                        </div>


                    </v-col>
                </v-row>





                <v-row no-gutters class="justify-center mt-5">

                    <v-btn
                        class="rounded-pill button--primary   text-body-2 font-weight-bold pa-6 px-7 d-flex"
                        @click="verifyPhoneNumber" :disabled="phoneVerificationInProcess || disableVerifyButton">
                        Verify Now
                    </v-btn>

                </v-row>




            </v-row>
        </BasicDialog>
    </div>
</template>



<script setup lang="ts">
import { AppConfigs } from "@/app.configs";
import { useSnackbar } from '@/composables/useSnackbar';
import { ref, computed } from 'vue';
import { UserActivityStore } from '@/store/UserActivityStore';
import BasicDialog from '@/components/Common/Basic-Dialog.vue';
import type { VerifyPhoneNumberInput } from '@/interfaces/InHouseTasks/VerifyPhoneNumberInput';

const emit = defineEmits<{
	(e: 'phoneNumberEntered', phoneNumberInput: VerifyPhoneNumberInput): void
}>();

const phone = ref('');
const { showSnackbar } = useSnackbar();
const valid = ref(false);
const country = ref('');
const countryCode = ref('');
const inHouseTasksStore = UserActivityStore();
const phoneVerificationInProcess = ref(false);

const onInput = ({ number, isValid, country: selectedCountry }: { number: string; isValid: boolean; country: { iso2: string } }) => {
	phone.value = number;
	valid.value = isValid;
	country.value = selectedCountry.iso2;
};

const onCountryChange = (selectedCountry: { dialCode: string }) => {
	countryCode.value = selectedCountry.dialCode;
};

const verifyPhoneNumber = async () => {
	if (!valid.value) {
		showSnackbar({
			message: 'Please enter a valid phone number.',
			color: 'error'
		});
		return;
	}

	phoneVerificationInProcess.value = true;
	try {
		const phoneNumberInput: VerifyPhoneNumberInput = {
			phone_number: phone.value,
			phone_country_code: countryCode.value,
			phone_iso_code: country.value
		};

		await inHouseTasksStore.sendOTP(phoneNumberInput);
		showSnackbar({
			message: 'OTP Sent successfully',
			color: 'info'
		});
		emit('phoneNumberEntered', phoneNumberInput);
	} catch (error: any) {
		showSnackbar({
			message: error.message || 'There was an error.',
			color: 'error'
		});
	} finally {
		phoneVerificationInProcess.value = false;
	}
};
</script>



<style scoped lang="scss">
// TODO: Check this
</style>